<script>
import { Bar } from 'vue-chartjs'
export default {
    name: 'sales',
    extends: Bar,
    props: {
        period: '',
        periodType: ''
    },
    computed: {
        getToken(){
            return this.$store.getters.getToken
        }
    },
    data(){
        return {
            data: [],
            values: [],
            chartdata: {
                labels: [],
                datasets: []
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: false
                }
            }
        }
    },
    methods: {
        updateData: function(){
            fetch(server + 'getgraphresales?token='+this.getToken+'&period='+this.period+'&periodtype='+this.periodType, {
                method: 'GET',
            })
                .then(response => (response.json()))
                .then(responseJSON => {
                    let data = responseJSON.data
                    let labels = []
                    let values = []

                    this.chartdata.labels = []
                    this.chartdata.datasets = []

                    for (let index = 0; index < data.length; index++) {
                        const element = data[index];
                        if(this.periodType == 'month'){
                            switch (parseInt(element.PERIODO)) {
                                case 1:
                                    labels.push('Jan / ' + element.ANO)
                                    break;
                                case 2:
                                    labels.push('Fev / ' + element.ANO)
                                    break;
                                case 3:
                                    labels.push('Mar / ' + element.ANO)
                                    break;
                                case 4:
                                    labels.push('Abr / ' + element.ANO)
                                    break;
                                case 5:
                                    labels.push('Mai / ' + element.ANO)
                                    break;
                                case 6:
                                    labels.push('Jun / ' + element.ANO)
                                    break;
                                case 7:
                                    labels.push('Jul / ' + element.ANO)
                                    break;
                                case 8:
                                    labels.push('Ago / ' + element.ANO)
                                    break;
                                case 9:
                                    labels.push('Set / ' + element.ANO)
                                    break;
                                case 10:
                                    labels.push('Out / ' + element.ANO)
                                    break;
                                case 11:
                                    labels.push('Nov / ' + element.ANO)
                                    break;
                                case 12:
                                    labels.push('Dez / ' + element.ANO)
                                    break;
                                default:
                                    labels.push('Mês / ' + element.ANO)
                                    break;
                            }
                        }else{
                            labels.push(element.PERIODO + ' / ' + element.MES)
                        }
                        values.push(element.TOTAL_RECEBIDO)
                    }

                    this.chartdata.labels = labels
                    this.chartdata.datasets.push({
                        label: 'Valor',
                        backgroundColor: '#f87979',
                        data: values
                    })
                    this.renderChart(this.chartdata, this.options)
                })
                .catch(error => (console.log(error)));
        }
    },
    mounted () {
        this.updateData()
    },
    watch: {
        period: function(newVal, oldVal) {
            this.updateData()
        }
    }
}
</script>
<style scoped>

</style>